import moment from 'moment-timezone';
import { FORMATS } from './core/formats';
export const SCHEDULE_DATE_MIN = '1900-01-01';
export const SCHEDULE_DATE_MAX = '9999-12-31';
const TIME_24H = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
/** Reject invalid or out-of-range YYYY-MM-DD (e.g. typed overflow in date inputs). */
export function sanitizeScheduleDateInput(value) {
    if (!value)
        return '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return '';
    const parsed = moment(value, FORMATS.moment.date, true);
    if (!parsed.isValid())
        return '';
    if (parsed.isBefore(SCHEDULE_DATE_MIN, 'day') || parsed.isAfter(SCHEDULE_DATE_MAX, 'day')) {
        return '';
    }
    return value;
}
/** Clamp complete HH:mm to 00:00–23:59; leave partial mask values unchanged while typing. */
export function sanitizeScheduleTimeInput(value) {
    const trimmed = (value || '').trim();
    if (!trimmed || trimmed.includes('_'))
        return trimmed;
    if (trimmed.length !== 5)
        return trimmed;
    const match = trimmed.match(/^(\d{1,2}):(\d{1,2})$/);
    if (!match)
        return trimmed;
    const hh = Math.min(23, Math.max(0, parseInt(match[1], 10) || 0));
    const mm = Math.min(59, Math.max(0, parseInt(match[2], 10) || 0));
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}
export function isValidScheduleTime(time) {
    return TIME_24H.test(time) || time === '24:00';
}
export function isValidScheduleDate(value) {
    return sanitizeScheduleDateInput(value) === value && !!value;
}
//# sourceMappingURL=schedule-field-input.js.map